import { render, staticRenderFns } from "./MiltonCity.vue?vue&type=template&id=d5d2aa82&scoped=true&"
import script from "./MiltonCity.vue?vue&type=script&lang=js&"
export * from "./MiltonCity.vue?vue&type=script&lang=js&"
import style0 from "./MiltonCity.vue?vue&type=style&index=0&id=d5d2aa82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d2aa82",
  null
  
)

export default component.exports